import {scaleBand, scaleLinear} from 'd3-scale';
import Default from '../default/';
import {zeroPoint} from '../../modules/util';

function _scale() {
  const scale = this.scale();
  const munged = this.__execs__.munged;
  const field = this.__execs__.field;
  let xAt = this.axisX();
  let yAt = this.axisY();
  let yDomain, xDomain, colorDomain;
  
  scale.x = scaleBand();
  scale.y = scaleBand();
  scale.color = scaleLinear();
  
  xDomain = Default.ordinalDomain(munged, 0, null, field.x.order);
  yDomain = Default.ordinalDomain(munged, 1, null, field.y.order);
  colorDomain = Default.continousDomain(munged, null, 1);
  
  scale.x.domain(xDomain);
  scale.y.domain(yDomain);
  if (field.x.interval && field.x.format) {
    xAt.tickFormat = field.x.format;
  } 
  if (field.y.interval && field.y.format) {
    yAt.tickFormat = field.y.format;
  } 
  this.thickness(yAt, scale.y, false, true);
  this.thickness(xAt, scale.x, true, true);

  const innerSize = this.innerSize();  
  scale.x.rangeRound([0, innerSize.width]).padding(this.padding());
  scale.y.rangeRound([0, innerSize.height]).padding(this.padding());
  
  if (zeroPoint(colorDomain)) {
    scale.color.domain([colorDomain[0], 0, colorDomain[colorDomain.length-1]])
  }
  scale.color.domain(colorDomain).range(this.color());
}



export default _scale;


// WEBPACK FOOTER //
// ./layouts/xy-heatmap/_scale.js